var _slicedToArray = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var concatStream = require('concat-stream');

var Readable = require('stream').Readable;

var path = require("path");

var fs = require("fs-extra");

var SolidFileStorage = /*#__PURE__*/function () {
  "use strict";

  function SolidFileStorage() {
    _classCallCheck(this, SolidFileStorage);

    this.prefix = "file";
    this.name = "solid-rest-file-storage-1.0.0";
  }

  _createClass(SolidFileStorage, [{
    key: "_makeStream",
    value: function _makeStream(text) {
      if (typeof text === 'object' && typeof text.stream === 'function') {
        return text.stream();
      }

      var s = new Readable();
      s.push(text);
      s.push(null);
      return s;
    }
  }, {
    key: "text",
    value: function () {
      var _text = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(stream) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", new Promise(function (resolve, reject) {
                  stream = stream || "";
                  if (typeof stream === "string") return resolve(stream);
                  stream.pipe(concatStream({
                    encoding: 'string'
                  }, resolve())).catch(function (e) {
                    console.log(e);
                    reject();
                  });
                  stream.on('error', reject());
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function text(_x) {
        return _text.apply(this, arguments);
      }

      return text;
    }()
  }, {
    key: "json",
    value: function () {
      var _json = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(stream) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", text(stream).then(function (text) {
                  return JSON.parse(text);
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function json(_x2) {
        return _json.apply(this, arguments);
      }

      return json;
    }()
  }, {
    key: "getObjectType",
    value: function () {
      var _getObjectType = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(fn, options) {
        var stat, type;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                try {
                  stat = fs.lstatSync(fn);
                } catch (err) {}

                type = stat && stat.isDirectory() ? "Container" : "Resource";
                if (!stat && fn.endsWith('/')) type = "Container";
                return _context3.abrupt("return", Promise.resolve([type, stat]));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function getObjectType(_x3, _x4) {
        return _getObjectType.apply(this, arguments);
      }

      return getObjectType;
    }()
  }, {
    key: "getResource",
    value: function () {
      var _getResource = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(pathname, options, objectType) {
        var bodyData;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return fs.readFile(pathname);

              case 2:
                bodyData = _context4.sent;
                return _context4.abrupt("return", [200, bodyData]);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function getResource(_x5, _x6, _x7) {
        return _getResource.apply(this, arguments);
      }

      return getResource;
    }()
    /*
    async putResource(pathname,options){
        return new Promise((resolve) => {
            options.body = this._makeStream( options.body );
            options.body.pipe(fs.createWriteStream(pathname)).on('finish',()=>{
              resolve( [201] )
            }).on('error', (err) => { 
              if(options.method==="PUT" && options.objectType==="Container")
                resolve( [405] )
              resolve( [500] )
            })
        })
    }
    */

  }, {
    key: "putResource",
    value: function () {
      var _putResource = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(pathname, options) {
        var _this = this;

        var successCode, failureCode;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                successCode = 201;
                failureCode = options.method === "PUT" && options.objectType === "Container" ? 409 : 500;
                return _context6.abrupt("return", new Promise( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(resolve) {
                    var writeIt, fileReader;
                    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            writeIt = false;

                            if (!(failureCode === 409)) {
                              _context5.next = 3;
                              break;
                            }

                            return _context5.abrupt("return", resolve([failureCode]));

                          case 3:
                            if (typeof options.body === "undefined") options.body = "";

                            if (!(typeof options.body === "string")) {
                              _context5.next = 8;
                              break;
                            }

                            writeIt = true;
                            _context5.next = 23;
                            break;

                          case 8:
                            if (!options.body.stream) {
                              _context5.next = 18;
                              break;
                            }

                            _context5.next = 11;
                            return options.body.stream();

                          case 11:
                            options.body = _context5.sent;
                            _context5.next = 14;
                            return options.body.read();

                          case 14:
                            options.body = _context5.sent;
                            writeIt = true;
                            _context5.next = 23;
                            break;

                          case 18:
                            if (!options.body.text) {
                              _context5.next = 23;
                              break;
                            }

                            _context5.next = 21;
                            return options.body.text();

                          case 21:
                            options.body = _context5.sent;
                            writeIt = true;

                          case 23:
                            if (!writeIt) {
                              _context5.next = 34;
                              break;
                            }

                            _context5.prev = 24;
                            _context5.next = 27;
                            return fs.writeFileSync(pathname, options.body);

                          case 27:
                            return _context5.abrupt("return", resolve([successCode]));

                          case 30:
                            _context5.prev = 30;
                            _context5.t0 = _context5["catch"](24);
                            console.log(_context5.t0);
                            return _context5.abrupt("return", resolve([failureCode]));

                          case 34:
                            if (!options.body.pipe && typeof FileReader != "undefined") {
                              fileReader = new FileReader();

                              fileReader.onload = function () {
                                fs.writeFileSync(pathname, Buffer.from(new Uint8Array(this.result)));
                              };

                              fileReader.onloadend = function () {
                                return resolve([successCode]);
                              };

                              fileReader.onerror = function (err) {
                                console.log(err);
                                return resolve([failureCode]);
                              };

                              fileReader.readAsArrayBuffer(options.body);
                            } else {
                              options.body = options.body || "";
                              options.body = _this._makeStream(options.body);
                              options.body.pipe(fs.createWriteStream(pathname)).on('finish', function () {
                                return resolve([successCode]);
                              }).on('error', function (err) {
                                console.log(err);
                                return resolve([failureCode]);
                              });
                            }

                          case 35:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5, null, [[24, 30]]);
                  }));

                  return function (_x10) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function putResource(_x8, _x9) {
        return _putResource.apply(this, arguments);
      }

      return putResource;
    }()
  }, {
    key: "deleteResource",
    value: function () {
      var _deleteResource = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(fn) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", new Promise(function (resolve) {
                  fs.unlink(fn, function (err) {
                    if (err) resolve([409]);else resolve([200]);
                  });
                }));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function deleteResource(_x11) {
        return _deleteResource.apply(this, arguments);
      }

      return deleteResource;
    }()
  }, {
    key: "deleteContainer",
    value: function deleteContainer(fn) {
      return new Promise(function (resolve) {
        fs.rmdir(fn, function (err) {
          if (err) {
            resolve([409]);
          } else {
            resolve([200]);
          }
        });
      });
    }
  }, {
    key: "postContainer",
    value: function postContainer(fn, options) {
      fn = fn.replace(/\/$/, '');
      return new Promise(function (resolve) {
        if (fs.existsSync(fn)) {
          return resolve([201]);
        }

        fs.mkdirp(fn, {}, function (err) {
          if (err) {
            return resolve([500]);
          } else {
            return resolve([201]);
          }
        });
      });
    }
  }, {
    key: "makeContainers",
    value: function () {
      var _makeContainers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(pathname, options) {
        var foldername, _ref2, _ref3, type, exists;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                foldername = path.dirname(pathname);
                _context8.next = 3;
                return this.getObjectType(foldername);

              case 3:
                _ref2 = _context8.sent;
                _ref3 = _slicedToArray(_ref2, 2);
                type = _ref3[0];
                exists = _ref3[1];

                if (exists) {
                  _context8.next = 16;
                  break;
                }

                _context8.prev = 8;
                fs.mkdirpSync(foldername);
                return _context8.abrupt("return", Promise.resolve([201]));

              case 13:
                _context8.prev = 13;
                _context8.t0 = _context8["catch"](8);
                return _context8.abrupt("return", Promise.resolve([500]));

              case 16:
                return _context8.abrupt("return", Promise.resolve([200]));

              case 17:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[8, 13]]);
      }));

      function makeContainers(_x12, _x13) {
        return _makeContainers.apply(this, arguments);
      }

      return makeContainers;
    }()
  }, {
    key: "getContainer",
    value: function () {
      var _getContainer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(pathname, options) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return fs.readdirSync(pathname);

              case 2:
                return _context9.abrupt("return", _context9.sent);

              case 3:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function getContainer(_x14, _x15) {
        return _getContainer.apply(this, arguments);
      }

      return getContainer;
    }()
  }]);

  return SolidFileStorage;
}();

module.exports = SolidFileStorage;
/*
  linux
    /home/travis/build/jeff-zucker/solid-rest/test-folder/rest/deep-folder

  osx
    /Users/travis/build/jeff-zucker/solid-rest/test-folder/rest/deep-folder
*/